import Vue from 'vue'
import VueRouter from 'vue-router'
import DefaultLayout from '@/layout/DefaultLayout'
import usercenter from '@/views/usercenter/usercenter.vue'
import store from '@/store'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: '/index',
    redirect: '/index',
    component: DefaultLayout,
    children:[
      {
        path: '/index',
        meta: {
          title: '千途图库',
          needLogin: false,
        },
        component: ()=>import('@/views/index.vue')
      }
    ]
  },
  { 
    path:'/home',
    component: DefaultLayout,
    redirect:'/home',
    children:[
      {
        path: '/home',
        meta: {
          title: '千途图库',
          needLogin: false,
        },
        component: ()=>import('@/views/Home.vue')
      }
    ]
  },
  { 
    path: '/search',
    component: DefaultLayout,
    redirect:'/search',
    children:[
      {
        path: '/search',
        meta: {
          title: '千途图库',
          needLogin: false,
        },
        component: ()=>import('@/views/Search.vue')
      }
    ]
  },
  { 
    path: '/vip',
    component: DefaultLayout,
    redirect:'/vip',
    children:[
      {
        path: '/vip',
        meta: {
          title: '千途图库 购买VIP',
          needLogin: true,
        },
        component: ()=>import('@/views/Vip.vue')
      }
    ]
  },
  {
    name: 'image',
    path: '/image',
    component: DefaultLayout,
    redirect:'image-detail',
    children:[
      {
        path: '/image-detail',
        meta: {
          title: '千途图库',
          needLogin: false,
        },
        component: ()=>import('@/views/ImageDetail.vue')
      }
    ]
  },
  {
    path: '/prepay',
    name: 'prepay',
    component: DefaultLayout,
    redirect:'prepay',
    children:[
      {
        path: '/prepay',
        meta: {
          title: '千途图库',
          needLogin: false,
        },
        component: ()=>import('@/views/PrePay.vue')
      }
    ]
  },
  {
    path:'/about',
    meta: {
      title: '千途图库',
      needLogin: false,
    },
    component: ()=>import('@/views/About.vue')
  },
  {
    path: '/usercenter',
    component: usercenter,
    redirect:'/usercenter/list',
    children:[
      {
        path: '/usercenter/list',
        meta: {
          title: '千途图库',
          needLogin: false,
        },
        component: ()=>import('@/views/usercenter/list.vue')
      },{
        path: '/usercenter/likes',
        meta: {
          title: '千途图库',
          needLogin: false,
        },
        component: ()=>import('@/views/usercenter/likes.vue')
      },{
        path: '/usercenter/imgs',
        meta: {
          title: '千途图库',
          needLogin: false,
        },
        component: ()=>import('@/views/usercenter/imgs.vue')
      },{
        path: '/usercenter/details',
        meta: {
          title: '千途图库',
          needLogin: false,
        },
        component: ()=>import('@/views/usercenter/details.vue')
      },{
        path: '/usercenter/withdrawal',
        meta: {
          title: '千途图库',
          needLogin: false,
        },
        component: ()=>import('@/views/usercenter/withdrawal.vue')
      }
    ]
  },
  { 
    path: '/QA',
    component: DefaultLayout,
    children:[
      {
        path: '/QA',
        meta: {
          title: '千途图库',
          needLogin: false,
        },
        component: ()=>import('@/views/QA.vue')
      }
    ]
  },
]
const originalPush = VueRouter.prototype.push
   VueRouter.prototype.push = function push(location) {
   return originalPush.call(this, location).catch(err => err)
}

const router = new VueRouter({
  mode: 'hash',
  base: process.env.BASE_URL,
  routes,
  scrollBehavior (to, from, savedPosition) {
    return { x: 0, y: 0 }
  }
})

router.beforeEach((to, from, next) => {
  // 设置标题
  if (to.meta && to.meta.title) {
    window.document.title = to.meta.title;
  }

  let isLogin = window.localStorage.getItem('isLogin');

  // 需要登录，并且未登录，则转去登录
  if (to.meta.needLogin && isLogin == 'false') {
    passportLogin.login();
  }

  next();
});

export default router
